import AssignedTags from '../../common/components/List/AssignedTags/index.js'
import {removeTagFromStocktakes} from '../../data/stocktakeTags.js'
import {hasStocktakeManageTagOnStocktakePermissionSelector} from '../../data/me.js'
import {useSelector} from '../../store.js'

/**
 *
 * @param {Object} props - The component props.
 * @param {String} props.referenceID - The reference ID of the Stocktake.
 * @param {Array} props.tags - The tags associated with the Stocktake.
 *
 * @returns {React.ReactElement} The rendered component.
 */
export default function StocktakeTags({referenceID, tags}) {
  const hasStocktakeManageTagOnStocktakePermission = useSelector(
    hasStocktakeManageTagOnStocktakePermissionSelector,
  )

  return (
    <AssignedTags
      tags={tags}
      hasManageTagOnOrderPermission={hasStocktakeManageTagOnStocktakePermission}
      onRemove={(tag) => removeTagFromStocktakes(tag.id, [referenceID])}
    />
  )
}
